import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // Intentar leer del localStorage, por defecto 'dark'
    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('app_theme') || 'dark';
    });

    useEffect(() => {
        // Aplicar la clase al elemento raíz (html o body)
        const root = document.documentElement;
        if (theme === 'dark') {
            root.classList.add('dark');
            root.classList.remove('light');
            root.style.setProperty('--bg-primary', '#171717');
            root.style.setProperty('--bg-secondary', '#252525');
            root.style.setProperty('--bg-tertiary', '#252525');
            root.style.setProperty('--text-primary', '#FFFFFF');
            root.style.setProperty('--text-secondary', '#9CA3AF'); // text-neutral-400
            root.style.setProperty('--border-color', 'rgba(255, 255, 255, 0.05)');
        } else {
            root.classList.add('light');
            root.classList.remove('dark');
            // Paleta Modo Claro Premium (Fondo Gris muy claro, Tarjetas Blancas)
            root.style.setProperty('--bg-primary', '#F3F4F6'); // gray-100
            root.style.setProperty('--bg-secondary', '#FFFFFF'); // white
            root.style.setProperty('--bg-tertiary', '#F9FAFB'); // gray-50
            root.style.setProperty('--text-primary', '#111827'); // gray-900
            root.style.setProperty('--text-secondary', '#4B5563'); // gray-600
            root.style.setProperty('--border-color', 'rgba(0, 0, 0, 0.05)');
        }
        localStorage.setItem('app_theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prev => prev === 'dark' ? 'light' : 'dark');
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
